export const SUBMENUS = [
  {
    id: 0,
    icon: 'team',
    name: '用户管理',
    items: [
      { id: 0, name: '会员管理', route: '/user/list', permissions: [{ action: 'read', resource: 'UserList' }] },
      { id: 1, name: '社群管理', route: '/group/skus/group', permissions: [{ action: 'read', resource: 'SkuList' }] },
      { id: 2, name: '班主任管理', route: '/teacher/list', permissions: [{ action: 'read', resource: 'TeacherList' }] },
      { id: 3, name: '优惠券管理', route: '/coupon/list', permissions: [{ action: 'read', resource: 'CouponList' }] },
      {
        id: 4,
        name: '签到管理',
        route: '/check-in/do-check-in',
        permissions: [{ action: 'create', resource: 'DoCheckIn' }],
      },
      { id: 5, name: '用户回访', route: '/return-visit', permissions: [{ action: 'read', resource: 'ReturnVisit' }] },
      {
        id: 6,
        name: '用户升级',
        route: '/enrollment/upgrade',
        permissions: [{ action: 'read', resource: 'EnrollmentUpgrade' }],
      },
    ],
  },
  {
    id: 1,
    icon: 'gift',
    name: '营销管理',
    items: [
      {
        id: 0,
        name: '活动管理',
        route: '/marketing/activities',
        permissions: [{ action: 'read', resource: 'MarketingActivityList' }],
      },
      { id: 1, name: '奖品管理', route: '/gifts/management', permissions: [{ action: 'read', resource: 'GiftsList' }] },
      { id: 2, name: '红包管理', route: '/redpack/list', permissions: [{ action: 'read', resource: 'RedpackList' }] },
      { id: 3, name: '库存管理', route: '/stock/list', permissions: [{ action: 'read', resource: 'StockList' }] },
      {
        id: 4,
        name: '兑换码模板',
        route: '/redeem-code-template/templatelist',
        permissions: [{ action: 'create', resource: 'RedeemCodeList' }],
      },
      {
        id: 5,
        name: '兑换码管理',
        route: '/redeem-code/list',
        permissions: [{ action: 'read', resource: 'RedeemCodeList' }],
      },
      {
        id: 6,
        name: '兑换码发送',
        route: '/redeem-code-send/send',
        permissions: [{ action: 'read', resource: 'RedeemCodeSend' }],
      },
    ],
  },

  {
    id: 2,
    icon: 'shopping-cart',
    name: '订单管理',
    items: [
      { id: 0, name: '订单列表', route: '/order/list', permissions: [{ action: 'read', resource: 'OrderList' }] },
      {
        id: 1,
        name: '物流列表',
        route: '/logistics/list',
        permissions: [{ action: 'read', resource: 'LogisticsList' }],
      },
    ],
  },

  {
    id: 3,
    icon: 'book',
    name: '课程管理',
    items: [
      { id: 0, name: '课程列表', route: '/course/list', permissions: [{ action: 'read', resource: 'CourseList' }] },
    ],
  },
  {
    id: 4,
    icon: 'line-chart',
    name: '数据统计',
    items: [
      {
        id: 0,
        name: '数据整理工具',
        route: '/tools/dateprocess',
        permissions: [{ action: 'read', resource: 'DateProcess' }],
      },
      {
        id: 1,
        name: '环节关卡统计',
        route: '/statistic/section-metrics',
        permissions: [{ action: 'read', resource: 'SectionMetrics' }],
      },
    ],
  },
  {
    id: 5,
    icon: 'control',
    name: '权限管理',
    items: [
      {
        id: 0,
        name: '角色列表',
        route: '/role-permission-role/role/list',
        permissions: [{ action: 'read', resource: 'RoleList' }],
      },
      {
        id: 1,
        name: '权限列表',
        route: '/role-permission-permission/permission/list',
        permissions: [{ action: 'read', resource: 'PermissionList' }],
      },
      {
        id: 2,
        name: '员工列表',
        route: '/role-permission-worker/worker/list',
        permissions: [{ action: 'read', resource: 'WorkerList' }],
      },
    ],
  },
  {
    id: 6,
    icon: 'file-protect',
    name: '工单管理',
    items: [
      {
        id: 0,
        name: '工单列表',
        route: '/work-order/list',
        permissions: [{ action: 'read', resource: 'WorkOrderList' }],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/screens/layouts/constant.ts